export const jobSearchStatuses = [
  { label: "Actively looking for a new position", value: "Actively looking for a new position" },
  { label: "Passively looking for a new position", value: "Passively looking for a new position" },
  { label: "Not looking for a new position", value: "Not looking for a new position" }
];

const JOB_CATEGORY_OPTIONS = [
  "Agronomy",
  "Agronomy Operations Staff",
  "Architecture",
  "Assistant Professional",
  "Association/Administration",
  "Clerical/Administrative",
  "Club Building/Fitting/Repair",
  "Director of Golf",
  "Executive Management",
  "Finance/Accounting",
  "Food & Beverage",
  "Golf Operations Support Staff",
  "Head Golf Professional",
  "Legal & Licensing",
  "Marketing/Communication/Public Relations",
  "Merchandise & Retail Operations",
  "OEM",
  "Teaching & Coaching",
  "Technology",
  "Sales/Partnerships",
  "All Others"
] as const;

export const jobCategories = [...JOB_CATEGORY_OPTIONS].sort((a, b) =>
  a.localeCompare(b, "en", { sensitivity: "base" })
);

export const minimumCompensationOptions = (() => {
  const options = [{ label: "No Minimum", value: "0" }];

  // $25,000 to $50,000 in $5,000 increments
  for (let i = 5; i <= 10; i++) {
    const amount = i * 5000;
    options.push({
      label: `$${amount.toLocaleString("en-US")}`,
      value: amount.toString()
    });
  }

  // $60,000 to $300,000 in $10,000 increments
  for (let i = 6; i <= 30; i++) {
    const amount = i * 10000;
    options.push({
      label: `$${amount.toLocaleString("en-US")}`,
      value: amount.toString()
    });
  }

  return options;
})();
